// extracted by mini-css-extract-plugin
export default {"divider":"ButtonsGroup_divider__dzHKt","group":"ButtonsGroup_group__oerxC","button":"ButtonsGroup_button__R-57A"};